"use strict";import{ClickController as o}from"./ClickController.js";import{HoverController as r}from"./HoverController.js";import{LongpressController as e}from"./LongpressController.js";export const strategies={click:o,longpress:e,hover:r};
//# sourceMappingURL=strategies.js.map
